/*
 * File: CreatedDateTimeSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 13 Dec 2021 8:21:10 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCreatedDateTime } from 'redux/salesOrder/ordersSlice';
import { FancyDatePicker } from '../FancyDatePicker';

const styles: InlineStylesModel = {
  titleColor: {
    // color: '#2F5596'
  }
};

export const CreatedDateTimeSearch = (): JSX.Element => {
  const [inputValue, _setInputValue] = useState<string | null>(null);
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  const handleChange = (date: any, dateString: any): void => {
    _setInputValue(dateString);
    if (dateString.length) {
      dispatch(setFilterCreatedDateTime(dateString));
    }
    if (!dateString.length) {
      dispatch(setFilterCreatedDateTime(undefined));
    }
  };

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyDatePicker onInputChange={handleChange} placeHolder={'Created Date'} value={inputValue ? inputValue : ''} width={150} />
    </Space>
  );
};
